import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/pastoral.css'

import App from './App.vue'
import router from './router'
import axiosPlugin from './plugins/axios'

const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.use(axiosPlugin)

app.mount('#app')
